// Firebase Cloud Messaging Configuration File. 
// Read more at https://firebase.google.com/docs/cloud-messaging/js/client && https://firebase.google.com/docs/cloud-messaging/js/receive

import { initializeApp } from 'firebase/app';
import { getMessaging, getToken } from 'firebase/messaging';


const firebaseConfig = {
    apiKey: "AIzaSyBwBzff-oYztgsf3CMw1P-EAy84euetOXg",
    authDomain: "gridsec-customer-portal-a8926.firebaseapp.com",
    projectId: "gridsec-customer-portal-a8926",
    storageBucket: "gridsec-customer-portal-a8926.appspot.com",
    messagingSenderId: "271328960735",
    appId: "1:271328960735:web:dd7ebd7634754c8890096a",
    measurementId: "G-QWFLGGRNS6"
};
const app = initializeApp(firebaseConfig);

const messaging = getMessaging(app);

export function requestForToken() {
    const token = new Promise((resolve) => {
        Notification.requestPermission().then((permission) => {
            if (permission === "granted") {
                var fcmToken = new Promise((resolve) => {
                    var token = ""
                    getToken(messaging, {
                        vapidKey: "BHuV7VulIQqTVOrgKuQzb5MzAxhpZINU7yXZKpKGEFUFr2mSaRvyRe-GjvtvEEObsjx7KdkiJAXUjv9RGJUjEVY",
                    }).then((currentToken) => {
                        if (currentToken) {
                            token = currentToken
                        } else {
                            console.error("Can not get token");
                        }
                        resolve(token)
                    });
                })
            } 
            resolve(fcmToken)
        });
    })
    return token
}

